// extracted by mini-css-extract-plugin
module.exports = {"content":"International_content__axecp","ef-box":"International_ef-box__mf46L"};